import * as React from 'react';
export const defaultContext = {
    log: (message) => console.error(message),
};
export const ErrorContext = React.createContext(defaultContext);
const ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(ErrorContext.Provider, { value: { log } }, props.children));
};
export default ErrorProvider;
